import { Route, Routes } from 'react-router-dom';
import Home from './pages/home.jsx';
import Notfound from './pages/notFound.jsx';  

function App() {
  return (
    <>
    {
    <Routes>
        <Route path='/' element={<Home showAboutIn={false} devMode={false}/>}/>
        <Route path='/about' element={ <Home showAboutIn={true}/> }/>
        <Route path='/*' element={<Notfound/>}/>
      </Routes>
    }
    </>
  );
}
export default App;

